/**
 * Deposit authorisation row — the gated consent a club ticks before it can accept a proposal that
 * requires a deposit (TW-3445). The accept action stays disabled until this is checked. A manual
 * acknowledgement only; no payment is taken here. Styling: `.deposit-auth`. Caller passes the
 * localised consent text.
 */
export interface DepositAuthorizeProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Localised consent text (e.g. "I authorise Travel Connection to pay the hotel deposit…"). */
  label: string;
  /** Grey out and lock the consent (e.g. while accepting is blocked by a pending amendment). */
  disabled?: boolean;
}

export function DepositAuthorize({ checked, onChange, label, disabled = false }: DepositAuthorizeProps) {
  return (
    <label className="deposit-auth" style={disabled ? { opacity: 0.55, cursor: "not-allowed" } : undefined}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>{label}</span>
    </label>
  );
}
